/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import UiSelectWithGraphicsOption from './UiSelectWithGraphicsOption'
import { UiSelectOption } from '../UiSelectWithGraphics'

interface UiSelectWithGraphicsGroupOptionsListProps {
    options: UiSelectOption[]
}

const UiSelectWithGraphicsGroupOptionsList = (
    props: UiSelectWithGraphicsGroupOptionsListProps
) => {
    if (!props.options.length) {
        return null
    }

    return (
        <>
            {props.options.map((option) => (
                <UiSelectWithGraphicsOption
                    key={option.value}
                    option={option}
                />
            ))}
        </>
    )
}

export default UiSelectWithGraphicsGroupOptionsList
